// r24 — /translate/naati/au/$slug (TH)
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiAuCityRenderer from "@/components/NaatiAuCityRenderer";
import { NAATI_AU_CITIES } from "@/data/naati-au-cities";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";

export const Route = createFileRoute("/translate/naati/au/$slug")({
  loader: ({ params }) => {
    const c = NAATI_AU_CITIES.find((x) => x.slug === params.slug);
    if (!c) throw notFound();
    return { city: c };
  },
  head: ({ params }) => {
    const c = NAATI_AU_CITIES.find((x) => x.slug === params.slug);
    if (!c) return { meta: [{ title: ctaTitle("Not found", "/translate/naati/au/$slug", "th")}, { name: "robots", content: "noindex" }] };
    const url = `${SITE}/translate/naati/au/${c.slug}`;
    const title = `แปล NAATI ส่ง ${c.nameTh} — DHL ${c.postageEtaFromBkk} | NYC`;
    const desc = `บริการแปล NAATI ส่ง${c.nameTh} (${c.stateEn}) ยื่นวีซ่า ${c.popularVisas.slice(0, 3).join(", ")} /หน้า — ปรึกษาก่อนยื่นจริง ลดโอกาสเอกสารตีกลับ`;
    return {
      meta: [
        { title: ctaTitle(title, "/translate/naati/au/$slug", "th") }, { name: "description", content: ctaDesc(desc, "/translate/naati/au/$slug", "th")},
        { property: "og:title", content: ctaTitle(title, "/translate/naati/au/$slug", "th")}, { property: "og:description", content: ctaDesc(desc, "/translate/naati/au/$slug", "th")},
        { property: "og:url", content: url }, { property: "og:locale", content: "th_TH" },
      ],
      links: canonicalAndHreflang(`/translate/naati/au/${c.slug}`, `/en/translate/naati/au/${c.slug}`),
      scripts: [
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "Service", inLanguage: "th",
          name: `NAATI Translation ส่ง ${c.nameTh}`,
          areaServed: { "@type": "City", name: c.nameEn, address: { "@type": "PostalAddress", addressRegion: c.stateEn, addressCountry: "AU" } },
          provider: { "@type": "Organization", name: "NYC Language Institute", url: SITE },
          url,
        }) },
      ],
    };
  },
  component: () => {
    const { city } = Route.useLoaderData();
    return <NaatiAuCityRenderer locale="th" city={city} />;
  },
});
